import React from "react";

import {
  ChevronLink,
  Columns,
  Column,
  Heading,
  Hidden,
  MarkdownLite,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import { IconElectricity, IconUsage } from "@origin-digital/ods-icons";
import {
  IParagraphContent,
  ITiledParagraphContent,
} from "src/pages/Spike/types";

const iconMap = {
  electricity: IconElectricity,
  usage: IconUsage,
};

export const ParagraphSection: React.FC<{
  content: IParagraphContent;
  backgroundColor?: "grey50" | "white" | "transparent";
}> = ({ content, backgroundColor = "white" }) => (
  <Section backgroundColor={backgroundColor}>
    <Columns collapseBelow="lg" space={["none", "large"]}>
      <Column width="1/6" />
      <Column width="2/3">
        <Stack space={["xlarge", "medium"]}>
          {content.sections.map((section, index) => (
            <Stack
              key={`section-${index}`}
              alignX={["left", "center"]}
              space={["medium", "large"]}
            >
              <Heading variant="h3" align={["left", "center"]}>
                {section.heading}
              </Heading>
              {section.textSection.map((text, idx) => (
                <Text align={["left", "center"]} key={`section-1-${idx}`}>
                  <MarkdownLite>{text}</MarkdownLite>
                </Text>
              ))}
              {content.cta && (
                <ChevronLink href={content.cta.url}>
                  {content.cta.text}
                </ChevronLink>
              )}
            </Stack>
          ))}
        </Stack>
      </Column>
      <Column width="1/6" />
    </Columns>
  </Section>
);

export const TileParagraphs: React.FC<{
  content: ITiledParagraphContent;
  backgroundColor?: "grey50" | "white" | "transparent";
}> = ({ content, backgroundColor = "white" }) => (
  <Section backgroundColor={backgroundColor}>
    <Hidden above="sm">
      <Stack space="xlarge" dividers>
        {content.sections.map((section, index) => (
          <Stack space="medium" key={`section-${index}`}>
            <Columns space="xxsmall" alignY="top">
              <Column>
                <Heading variant="h3">{section.heading}</Heading>
              </Column>
              <Column width="content">
                {React.createElement(iconMap[section.icon])}
              </Column>
            </Columns>
            {section.textSection.map((text, idx) => (
              <Text align="left" key={`section-1-${idx}`}>
                <MarkdownLite>{text}</MarkdownLite>
              </Text>
            ))}
            {section.cta && (
              <ChevronLink href={section.cta.url}>
                {section.cta.text}
              </ChevronLink>
            )}
          </Stack>
        ))}
      </Stack>
    </Hidden>
    <Hidden below="md">
      <Stack space="xxlarge">
        <Columns>
          {content.sections.map((section, index) => (
            <Column key={`section-${index}`}>
              <Stack space="medium">
                {React.createElement(iconMap[section.icon], { size: "medium" })}
                <Heading variant="h3">{section.heading}</Heading>
                {section.textSection.map((text, idx) => (
                  <Text align="left" key={`section-1-${idx}`}>
                    <MarkdownLite>{text}</MarkdownLite>
                  </Text>
                ))}
                {section.cta && (
                  <ChevronLink href={section.cta.url}>
                    {section.cta.text}
                  </ChevronLink>
                )}
              </Stack>
            </Column>
          ))}
        </Columns>
      </Stack>
    </Hidden>
  </Section>
);
